import Icon from "../../Icons/general/Icon";
import PropTypes from "prop-types";

const CardTurno = ({ data, servicio, disabled, onClick }) => {
  const activo = data?.TurnoRes > 0 ;
    return (
      <>
        <div className={`flex flex-row w-full h-[6rem] mb-4 rounded-lg shadow-lg shadow-default border border-stone-200 disabled 
                        ${disabled ? 'opacity-50 pointer-events-none' : 'hover:cursor-pointer hover:bg-body'} 
                        ${activo ? 'bg-white opacity-100' : 'bg-gray-200 opacity-50 pointer-events-none'}`}
                        id={`card${servicio.AreaId}${servicio.ServicioId}`}
                        >

             <div className="w-full h-full flex flex-row">
                <div className="flex w-[5rem] md:w-[6rem] h-full text-center items-center justify-center text-[0.95rem] lg:text-[2rem] font-bold text-body leading-none border-stone-500 bg-sidebar px-4 rounded-l-lg">
                   <span>{servicio.Prefijo}</span>
                </div>
                <div className="flex flex-1 flex-row text-center items-center justify-center bg-light ">
                   <div className="w-full h-full flex flex-col">
                       <span id={`aten${servicio.AreaId}${servicio.ServicioId}`} className="font-bold text-atendido text-[2.2rem]">{data?.TurnoAten ?? 0}</span>
                       <span className="text-[0.75rem] md:text-xs font-light text-gray-500">Atendidos</span>
                   </div>
                   <div className="w-full h-full flex flex-col">
                       <span id={`tot${servicio.AreaId}${servicio.ServicioId}`} className="font-bold text-poratender text-[2.2rem]">{data?.TurnoRes ?? 0}</span>
                       <span className=" text-[0.75rem] text-xs md:text-xs font-light text-gray-500">Por Atender</span>
                   </div>
                   <div className="w-full h-full flex flex-col">
                      <span id={`pend${servicio.AreaId}${servicio.ServicioId}`}  className="font-bold text-pendiente text-[2.2rem]">{data?.TurnoPend ?? 0}</span>
                      <span className="text-[0.75rem] text-xs md:text-xs font-light text-gray-500">Pendientes</span>
                   </div>
                </div>
             <div
              className="flex w-[5.5rem] md:w-[6rem] h-full text-[0.95rem] lg:text-[1.5rem] items-center justify-center font-bold text-body leading-none border-stone-500 bg-gray-400 px-4 rounded-r-lg touch-manipulation"
              onClick={()=> activo && onClick(data)}
              id={`btn${servicio.AreaId}${servicio.ServicioId}`}
            >
              <Icon
                svg="phone"
                data-area1={servicio.AreaId}
                data-servicio1={servicio.ServicioId}
                className="w-[3.5rem] h-[3.5rem] md:w-[4rem] md:h-[4rem] text-body fill-body "
                title="phone"
              />
            </div>
          </div>
        </div>
      </>
    );
  };
  CardTurno.propTypes = {
     data:PropTypes.object, 
     servicio:PropTypes.object, 
     disabled: PropTypes.bool.isRequired,
     onClick: PropTypes.func
  };
  
export default CardTurno;
